interface SectionDividerProps {
  label: string;
}

export const SectionDivider = ({ label }: SectionDividerProps) => (
  <div className="flex items-center gap-2 min-h-5 px-2 w-full">
    <span className="text-body-quiet text-size-body-xs font-semibold tracking-wider shrink-0">
      {label}
    </span>
    <div className="w-full h-px bg-[var(--border-neutral-silent)]" />
  </div>
);
